import _ from 'lodash';

let subscriptions = [];

export function subscribe(cb) {
    subscriptions.push(cb);
}

export function alert(alert) {
    if (_.isString(alert)) {
        alert = {
            type: 'alert-warning',
            text: alert
        };
    }
    subscriptions.forEach(s => s(alert));
}